import { Component } from '@angular/core';
import { USAGE_GUIDELINES_URL } from '../../usage-guidelines';

@Component({
  selector: 'app-usage-guidelines-banner',
  standalone: true,
  templateUrl: './usage-guidelines-banner.component.html',
  styleUrls: ['./usage-guidelines-banner.component.scss'],
})
export class UsageGuidelinesBannerComponent {
  readonly usageGuidelinesUrl = USAGE_GUIDELINES_URL;
}
